import { PACKAGES_BOOKMARKED } from "../constants/types";

export default function(state=[], action){
    switch(action.type){
      case PACKAGES_BOOKMARKED:
        return action.payload
      default:
        return state
    }
  }